var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "componentPropertiesModal",
        size: "lg",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("message.component_properties"),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT,
                      expression: "PERMISSIONS.PORTFOLIO_MANAGEMENT",
                    },
                  ],
                  attrs: {
                    size: "md",
                    variant: "outline-danger",
                    disabled: !_vm.hasRowsSelected,
                  },
                  on: { click: _vm.deleteProperty },
                },
                [_vm._v(_vm._s(_vm.$t("message.delete")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: _vm.PERMISSIONS.PORTFOLIO_MANAGEMENT,
                      expression: "PERMISSIONS.PORTFOLIO_MANAGEMENT",
                    },
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.componentCreatePropertyModal",
                      modifiers: { componentCreatePropertyModal: true },
                    },
                  ],
                  attrs: { size: "md", variant: "primary" },
                },
                [_vm._v(_vm._s(_vm.$t("message.create_property")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
        on: {
          "on-check": _vm.onRowSelectionChange,
          "on-uncheck": _vm.onRowSelectionChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }